import { SharedService } from 'src/app/Service/shared.service';
import { Component, Input, OnInit } from '@angular/core';
import { Global } from 'src/app/Service/global.service';
import { MvmNaviresService } from 'src/app/Service/mvm-navires.service';
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { PortMarocService } from 'src/app/Service/port-maroc.service';
import { Route } from '@angular/compiler/src/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil, map } from 'rxjs/operators';
import { OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY } from '@angular/cdk/overlay/dispatchers/overlay-keyboard-dispatcher';

@Component({
  selector: 'app-mvm-navires-autorisee',
  templateUrl: './mvm-navires-autorisee.component.html',
  styleUrls: ['./mvm-navires-autorisee.component.scss'],
})
export class MvmNaviresAutoriseeComponent implements OnInit {
  @Input()
  portId;
  constructor(
    public global: Global,
    private service: MvmNaviresService,
    private portService: PortMarocService,
    private sharedService: SharedService
  ) {}

  mvmNaviresGlobals;
  portsAutorisee = [];
  ports = [];
  provenance = [];
  consignataire = [];
  typeNavire = [];
  situation = [];
  selectedPort = '';
  selectedprovenance = '00';
  selectedConsignataire = '00';
  selectedTypeNavire = '00';
  selectedSituation = '00';
  showFilterPorts = false;
  filters = [];
  bloctitle = {
    title: '',
    contenu: '',
  };
  blocFooter = {
    title: '',
    contenu: '',
  };

  ngOnInit(): void {
    this.global.CurentLanguage.pipe( takeUntil(this.global.navigationEnd) ).subscribe((lg) => {
      this.sharedService
        .getBlocDescriptionByCode(lg.url, 'mouvement_navire_autorisee')
        .subscribe((datas) => {
          this.bloctitle.title = datas['value'][0].Title;
          this.bloctitle.contenu = datas['value'][0].Contenu;
        });
      this.sharedService
        .getBlocDescriptionByCode(lg.url, 'mouvement_navire2')
        .subscribe((datas) => {
          this.blocFooter.title = datas['value'][0].Title;
          this.blocFooter.contenu = datas['value'][0].Contenu;
        });

      this.service.getMvmNaviresAutorisee().subscribe((data) => {
        this.mvmNaviresGlobals = _.groupBy(data, 'cODE_SOCIETEField');
        this.portsAutorisee = Object.keys( _.groupBy(data, 'cODE_SOCIETEField')) as Array<keyof typeof data>; 
        if (this.portId !== undefined && this.portId !== null) {
          this.selectedPort =
            this.portId < 10 ? '0' + this.portId : '' + this.portId;
          this.portchange();
          this.showFilterPorts = true;
        }
        this.portService.getPortID().subscribe((ids) => {
          //Begin ANP
          console.log(this.portsAutorisee);
          ids['value'].forEach((filter) => {
            let codeport =
              filter.IdPort < 10 ? '0' + filter.IdPort : '' + filter.IdPort;
            this.portsAutorisee.filter((x) => {
              if (x == codeport) {
                this.ports.push(filter);
              }
            });
          });
          // END ANP
        });
      });
    });
  }
  portchange() {
    // let i;
    // id<10 ? i='0'+id : i=''+id;
    // this.selectedPort = i;
    const i = this.selectedPort;
    this.selectedprovenance = '00';
    this.selectedConsignataire = '00';
    this.selectedTypeNavire = '00';
    this.selectedSituation = '00';
    this.provenance = _.uniq(
      _.flatMap(this.mvmNaviresGlobals[i], ({ pROVField }) =>
        _.split(pROVField, ' , ')
      )
    );
    this.consignataire = _.uniq(
      _.flatMap(
        this.mvmNaviresGlobals[i],
        ({ cONSIGNATAIREField }) => cONSIGNATAIREField
      )
    );
    this.typeNavire = _.uniq(
      _.flatMap(
        this.mvmNaviresGlobals[i],
        ({ tYP_NAVIREField }) => tYP_NAVIREField
      )
    );
    this.situation = _.uniq(
      _.flatMap(
        this.mvmNaviresGlobals[i],
        ({ sITUATIONField }) => sITUATIONField
      )
    );

    this.lancerFiltre();
  }
  lancerFiltre() {
    this.filters = [
      { field: 'pROVField', value: this.selectedprovenance },
      { field: 'cONSIGNATAIREField', value: this.selectedConsignataire },
      { field: 'tYP_NAVIREField', value: this.selectedTypeNavire },
      { field: 'sITUATIONField', value: this.selectedSituation },
    ];
  }
  getDate(d) {
    return new Date(
      +d.split('(')[1].split(')')[0].split('+')[0]
    ).toLocaleDateString();
  }
  getHeure(h) {
    return new Date(+h.split('(')[1].split(')')[0].split('+')[0])
      .toLocaleTimeString()
      .substring(0, 5);
  }
}

@Pipe({ name: 'mvmNvFilter' })
export class MvmNaviresFilterPipe implements PipeTransform {
  transform(objet: [], filters: { value; field }[]): any[] {
    return objet.filter((element) => {
      let a = true;
      filters.forEach((filter) => {
        if (filter.value != '00') {
          a =
            a &&
            _.includes(
              String(element[filter.field]).split(' , '),
              filter.value
            );
        }
      });
      return a;
    });
  }
}
